import { render } from "./Ouvert.vue?vue&type=template&id=244fa9d8&functionnal=true"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.35_vue@3.5.35_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__